import type { HTMLAttributes } from 'react';
import { cn } from '@kawai/ui';

export type NoticeTone = 'danger' | 'success' | 'warning' | 'neutral';

export interface NoticeProps extends HTMLAttributes<HTMLParagraphElement> {
  /** 既定 danger。悪い側は面を作らず文字色だけ（docs/UI-GUIDE.md「状態の色」）。 */
  tone?: NoticeTone;
}

const TONES: Record<NoticeTone, string> = {
  danger: 'text-body text-danger-ink',
  success: 'rounded-lg bg-success-tint px-[18px] py-3 text-label text-success-ink',
  warning: 'rounded-lg bg-warning-tint px-[18px] py-3 text-label text-warning-ink',
  neutral: 'rounded-lg bg-surface-2 px-[18px] py-3 text-label text-ink-2',
};

/**
 * S-137: 結果・警告・エラーの短文（v2）。白カードの中に置く前提（danger は面を持たないので
 * ページ地色の上では見えにくい）。role="alert" / role="status" は呼び出し側で付ける。
 */
export function Notice({ tone = 'danger', className, ...rest }: NoticeProps) {
  return <p className={cn(TONES[tone], className)} {...rest} />;
}
